/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-03-13 09:13:26
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-08 10:52:34
 */
import request from '../../utils/request'
import server from './config'
export default {
    /**
     * 获取协议详情
     */
    getDetail:(params)=>{
        return request({
            url:`${server.MS_DOCTOR_CONSUMMER}/doctor/banner/1/detail`,
            method: 'get',
            params,
        })
    },
    isSignUp:(data)=>{
        return request({
            url:`${server.MS_DOCTOR_CONSUMMER}/doctor/banner/1/isSignUp`,
            method: 'post',
            data,
        })
    },
    signUp:(data)=>{
        return request({
            url:`${server.MS_DOCTOR_CONSUMMER}/doctor/banner/1/signUp`,
            method: 'post',
            data,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/modules/banner.js